var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtubes"},[_c('iframe',{attrs:{"src":`https://player.vimeo.com/video/${_vm.code}?autoplay=0&mute=0&modestbranding=1`,"width":"640","height":"360","frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }